import React, { useState } from "react";
import { Plus, Trash2 } from "react-feather";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import Swal from "sweetalert2";


function AddPackages() {
  const [showModal, setShowModal] = useState(false);
  const [keyValueRows, setKeyValueRows] = useState([{ key: "", value: "" }]);
  const [bannerImage, setBannerImage] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleAddRow = () => {
    setKeyValueRows([...keyValueRows, { key: "", value: "" }]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = keyValueRows.filter((_, i) => i !== index);
    setKeyValueRows(updatedRows);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = keyValueRows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setKeyValueRows(updatedRows);
  };

 
  const [previewImage, setPreviewImage] = useState(null); // Stores the preview URL
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file)); // Set preview
      setBannerImage(file); // Set actual file
    }
  };
  
 

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show spinner
  
    // Prepare FormData
    const formData = new FormData();
    if (bannerImage) {
      formData.append("bannerImage", bannerImage);
    }
    formData.append("packageName", e.target.packageName.value);
    formData.append("packageDescription", e.target.packageDescription.value);
    formData.append("price", e.target.price.value);
  
    // Prepare key-value pairs from the form rows
    const keyValueArray = keyValueRows.map((row) => ({
      key: row.key,
      value: row.value,
    }));
  
    // Append key-value pairs as JSON string
    formData.append("keyValuePairs", JSON.stringify(keyValueArray));
  
    try {
      // Sending data to backend
      const response = await axios.post(`${baseurl}InsertPackagenew`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      console.log("Package added:", response.data);
  
      // Show success alert
      Swal.fire({
        title: "Success!",
        text: "Package added successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload(); // Reload page after clicking OK
      });
  
    } catch (error) {
      console.error("Error sending data:", error);
  
      // Show error alert
      Swal.fire({
        title: "Error!",
        text: "Failed to add package. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Hide spinner after request is complete
    }
  };
  
  

  return (
    <>
      {/* Add Package Button */}
      <span className="btn3" onClick={handleOpenModal}>
        <Plus size={17} /> Add Package
      </span>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Add Package</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Banner Image */}
                  <div className="col-md-12 mb-3">
  <label className="text-dark mb-1 labelset2 font3 text-start">
    Package Banner Image
  </label>
  <input
    type="file"
    className="input1"
    accept="image/*"
    onChange={handleFileChange}
  />
  {previewImage && (
    <div className="mt-2">
      <img
        src={previewImage}
        alt="Banner Preview"
        className="img-fluid"
        style={{ maxWidth: "100%", maxHeight: "300px" }}
      />
    </div>
  )}
</div>


                  {/* Package Name, Description, and Price */}
                  <div className="row g-1 text-start">
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Package Name
                      </label>
                      <input
                        type="text"
                        className="input1"
                        name="packageName"
                        placeholder="Enter package name"
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Package Description
                      </label>
                      <textarea
                        className="inputtextarea"
                        name="packageDescription"
                        placeholder="Enter package description"
                        rows="3"
                      ></textarea>
                    </div>
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Price
                      </label>
                      <input
                        type="number"
                        className="input1"
                        name="price"
                        placeholder="Enter price"
                      />
                    </div>
                  </div>

                  {/* Key-Value Pairs */}
                  <div className="mt-3">
                    <h6 className="text-start text-dark">Package Details</h6>
                    {keyValueRows.map((row, index) => (
                      <div key={index} className="row g-2 align-items-center mb-2">
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="input1"
                            placeholder="Example Test : Day 1 - Delhi - Haridwar (250 Kms / 06 Hrs)"
                            value={row.key}
                            onChange={(e) =>
                              handleInputChange(index, "key", e.target.value)
                            }
                          />
                        </div>
                        <div className="col-md-12">
                          <textarea
                            className="inputtextarea"
                            placeholder="Details about this package"
                            rows={4}
                            value={row.value}
                            onChange={(e) =>
                              handleInputChange(index, "value", e.target.value)
                            }
                          ></textarea>
                        </div>
                        <div className="col-md-12 text-end">
                          <span
                            className="btn2"
                            title="Delete"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <Trash2 size={15} />
                          </span>
                        </div>
                      </div>
                    ))}

                    <div className="text-start">
                      <button
                        type="button"
                        className="btn4 btn-sm"
                        onClick={handleAddRow}
                      >
                        <Plus size={15} /> Add Row
                      </button>
                    </div>
                  </div>

                  {/* Save Button */}
                  <div className="text-end mt-3">
  <button type="submit" className="submit-btn" disabled={loading}>
    {loading ? (
      <>
        <span className="spinner-border spinner-border-sm me-2"></span>
        Adding Package...
      </>
    ) : (
      "Save Package"
    )}
  </button>
</div>

                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddPackages;
